import { useState } from "react";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";
import "../../style/AlbumAudioPlayerSmall.css";

const AlbumAudioPlayerSmall = ({
  audioObject = null,
  album = null,
  group = null,
  trackName = ""
}) => {
  const { isPlaying, play, pause, setVolume, volume } = audioObject;
  const [isMuted, setIsMuted] = useState(false);
  const [savedVolume, setSavedVolume] = useState(volume);

  const handleMute = () => {
    if (isMuted) {
      setVolume(savedVolume); // remettre l'ancien volume
      setIsMuted(false);
    } else {
      setSavedVolume(volume); // mémoriser le volume actuel avant de couper
      setVolume(0);
      setIsMuted(true);
    }
  };
  
  const handleVolumeChange = (e) => {
    const newVol = e.target.value / 100;
    setVolume(newVol);
  
    // si on change le volume via le slider et que le volume > 0 => on n’est plus mute
    if (newVol > 0) {
      setIsMuted(false);
      setSavedVolume(newVol); // met à jour le volume sauvegardé seulement si on n'est pas mute
    }
  };

  const togglePlay = () => {
    isPlaying ? pause() : play();
  };

  return (
    <div className="albumAudioPlayerSmall_player">
      <button
        type="button"
        onClick={togglePlay}
        className="albumAudioPlayerSmall_button"
      >
        <img
          src={`${import.meta.env.BASE_URL}${album?.imageUrl}`}
          alt={album?.albumTitle}
          className="albumAudioPlayerSmall_image"
        />
        {isPlaying ? (
          <Pause className="albumAudioPlayerSmall_playPause" size={24} />
        ) : (
          <Play className="albumAudioPlayerSmall_playPause" size={24} />
        )}
      </button>
      <div className="albumAudioPlayerSmall_info">
        <p className="albumAudioPlayerSmall_title">
          {trackName
            ? `${trackName} (${album?.truncatedTitle})`
            : album?.truncatedTitle}
        </p>
        <p className="albumAudioPlayerSmall_group">{group?.name}</p>
      </div>
      <div className="albumAudioPlayerSmall_volumeDiv">
        <button
          aria-label="mute audio"
          className="albumAudioPlayerSmall_volumeMuteButton"
          title={isMuted ? "son désactivé" : "son activé"}
          type="button"
          onClick={handleMute}
        >
          {isMuted ? (
            <VolumeX color="#fff" size={30} strokeWidth={1.25} />
          ) : (
            <Volume2 color="#fff" size={30} strokeWidth={1.25} />
          )}
        </button>
        <input
          type="range"
          min="0"
          max="100"
          value={Math.round(volume * 100)}
          onChange={handleVolumeChange}
          className="albumAudioPlayerSmall_volumeInput"
        />
      </div>
    </div>
  );
};

export default AlbumAudioPlayerSmall;
